<ion-card>
  @if (!b2bOnly) {
<!--    @if (!isSuccess) {-->
<!--      <h4>{{ formType !== formTypes.feedback ? formType === formTypes.complaints ? ('contact.form.complaints.title' | translate) : '' : hideFeedbackForm ? ('contact.form.feedback.satisfaction' | translate) : ('contact.form.feedback.title' | translate) }}</h4>-->
<!--    }-->
    @if (formType !== formTypes.feedback && !hideTab()) {
      <ion-segment
        (ionChange)="updateForm()"
        [value]="formTypes.contact"
        [(ngModel)]="formType"
        [dir]="languageService.dir()">
        @for (status of formTypesNames; track status) {
          @if (status.name !== formTypes.feedback) {
          <ion-segment-button [value]="status.type">{{status.name}}</ion-segment-button>
          }
        }
      </ion-segment>
    }
  }
  @switch (formType) {
    @case (formTypes.contact) {
      <form [formGroup]="contactForm" (submit)="sendRequest()" [lang]="languageService.lang()" [dir]="languageService.dir()">
        <ion-label>{{formTextContent?.formLabel.name}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   formControlName="name"
                   placeholder="{{ 'contact.form.name.placeholder' | translate }}"
        ></ion-input>

        <ion-label>{{formTextContent?.formLabel.email}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.email.placeholder' | translate }}"
                   formControlName="email" type="email"></ion-input>

        <app-select-country [userInput]="prefix" (countrySelected)="countrySelected($event)"></app-select-country>
        <ion-label>{{formTextContent?.formLabel.phone}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.phone.placeholder' | translate }}"
                   (ionInput)="validateNumber($event)"
                   formControlName="contactNumber">
          <span slot="start">{{prefix}}</span>
        </ion-input>

        <ion-label>{{formTextContent?.formLabel.subject}}</ion-label>
        <ion-select fill="outline"
                    [dir]="languageService.dir()"
                    mode="md"
                    interface="popover"
                    placeholder="{{ 'contact.form.subject.placeholder' | translate }}"
                    aria-label="{{ 'contact.form.subject.placeholder' | translate }}"
                    formControlName="subject">
          @for (status of formTextContent?.formGeneralDropdown; track status) {
            <ion-select-option [value]="status"
                               [dir]="languageService.dir()">{{status}}</ion-select-option>
          }
        </ion-select>
        <ion-label>{{formTextContent?.formLabel.message}}</ion-label>
        <ion-textarea
          style="height: 100px"
          [errorText]="formTextContent?.formErrorMessages.mandatoryError"
          fill="outline"
          mode="md"
          placeholder="{{ 'contact.form.message.placeholder' | translate }}"
          formControlName="message"></ion-textarea>
        <div class="text-align-right">
          <ion-button type="submit">{{ formTextContent?.formErrorMessages.button }}</ion-button>
        </div>
      </form>
    }
    @case (formTypes.complaints) {
      <form [formGroup]="complaintsForm" (submit)="sendRequest()" [lang]="languageService.lang()" [dir]="languageService.dir()">
        <ion-label>{{formTextContent?.formLabel.name}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   formControlName="name"
                   placeholder="{{ 'contact.form.name.placeholder' | translate }}"
        ></ion-input>

        <ion-label>{{formTextContent?.formLabel.email}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.email.placeholder' | translate }}"
                   formControlName="email" type="email"></ion-input>

        <app-select-country [userInput]="prefix" (countrySelected)="countrySelected($event)"></app-select-country>
        <ion-label>{{formTextContent?.formLabel.phone}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.phone.placeholder' | translate }}"
                   (ionInput)="validateNumber($event)"
                   formControlName="contactNumber">
          <span slot="start">{{prefix}}</span>
        </ion-input>
        <ion-label>{{formTextContent?.formLabel.complaint}}</ion-label>
        <ion-textarea
          style="height: 100px"
          [errorText]="formTextContent?.formErrorMessages.mandatoryError"
          fill="outline"
          mode="md"
          placeholder="{{ 'contact.form.complaint.placeholder' | translate }}"
          formControlName="message"></ion-textarea>
        <div class="text-align-right">
          <ion-button type="submit">{{ formTextContent?.formErrorMessages.button }}</ion-button>
        </div>
      </form>
    }
    @case (formTypes.b2c) {

      <form [formGroup]="b2cForm" (submit)="sendRequest()">
        <ion-label>{{formTextContent?.formLabel.name}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   formControlName="name"
                   placeholder="{{ 'contact.form.name.placeholder' | translate }}"
        ></ion-input>

        <ion-label>{{formTextContent?.formLabel.email}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.email.placeholder' | translate }}"
                   formControlName="email" type="email"></ion-input>

        <app-select-country [userInput]="prefix" (countrySelected)="countrySelected($event)"></app-select-country>
        <ion-label>{{formTextContent?.formLabel.phone}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.phone.placeholder' | translate }}"
                   (ionInput)="validateNumber($event)"
                   formControlName="contactNumber">
          <span slot="start">{{prefix}}</span>
        </ion-input>

        <ion-label>{{formTextContent?.formLabel.leaseDuration}}</ion-label>
        <ion-radio-group [dir]="languageService.dir()"
                    [lang]="languageService.lang()"
                    formControlName="leaseDuration">
          @for (duration of formTextContent?.durationDropDown; track duration) {
            <ion-radio [value]="duration">{{ duration }}</ion-radio>
          }
        </ion-radio-group>
        <ion-label>{{formTextContent?.formLabel.moveInDate}}</ion-label>
        <ion-input fill="outline" mode="md"
                   [readonly]="true"
                   formControlName="moveInDate"
                   placeholder="{{ 'contact.form.moveInDate.placeholder' | translate }}"
                   [errorText]="formTextContent?.formErrorMessages.mandatory">
          <ion-buttons slot="end">
            <ion-button id="datetime" aria-label="{{ 'contact.form.moveInDate.placeholder' | translate }}">
              <ion-icon name="calendar-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-input>

        <ion-modal #dateTimePicker
                   class="date-picker-model"
                   trigger="datetime" [keepContentsMounted]="true">
          <ng-template>
            <div class="ion-padding">
              <ion-datetime (ionChange)="datePicked($event); dateTimePicker.dismiss()"
                            presentation="date" mode="md"></ion-datetime>
            </div>
          </ng-template>
        </ion-modal>

        <ion-label>{{formTextContent?.formLabel.message}}</ion-label>
        <ion-textarea
          style="height: 100px"
          [errorText]="formTextContent?.formErrorMessages.mandatoryError"
          fill="outline"
          mode="md"
          placeholder="{{ 'contact.form.message.placeholder' | translate }}"
          formControlName="message"></ion-textarea>
        <div class="text-align-right">
          <ion-button type="submit">{{ formTextContent?.formErrorMessages.button }}</ion-button>
        </div>
      </form>
    }
    @case (formTypes.b2b) {
      <form [formGroup]="b2bForm" (submit)="sendRequest()"
            [lang]="languageService.lang()"
            [dir]="languageService.dir()">
        <ion-label>{{formTextContent?.formLabel.propertyOwner}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.companyName.placeholder' | translate }}"
                   formControlName="companyName"></ion-input>

        <ion-label>{{formTextContent?.formLabel.contactPerson}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.contactPerson.placeholder' | translate }}"
                   formControlName="name"></ion-input>

        <ion-label>{{formTextContent?.formLabel.email}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   formControlName="email"
                   placeholder="{{ 'contact.form.email.placeholder' | translate }}"
                   type="email"></ion-input>

        <app-select-country [userInput]="prefix" (countrySelected)="countrySelected($event)"></app-select-country>
        <ion-label>{{formTextContent?.formLabel.phone}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   placeholder="{{ 'contact.form.phone.placeholder' | translate }}"
                   (ionInput)="validateNumber($event)"
                   formControlName="contactNumber">
          <span slot="start">{{prefix}}</span>
        </ion-input>

        <ion-label>{{formTextContent?.formLabel.propertyAddress}}</ion-label>

        <div class="map-wrapper">

          <google-map [center]="coordinates" [zoom]="14"
                      width="100%" height="300px"
                      [options]="mapOptions">
            <map-marker [position]="coordinates"
                        [draggable]="true"
                        [options]="markerOptions"
                        (markerInitialized)="markerInitialized($event)"
                        (mapDragend)="mapMarkerChanged($event)"></map-marker>
          </google-map>
        </div>

<!--        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"-->
<!--                   fill="outline" mode="md"-->
<!--                   formControlName="propertyAddress"></ion-input>-->

        <ion-label>{{formTextContent?.formLabel.propertyType}}</ion-label>
        <ion-select fill="outline"
                    mode="md"
                    placeholder="{{ 'contact.form.propertyType.placeholder' | translate }}"
                    [lang]="languageService.lang()"
                    [dir]="languageService.dir()"
                    interface="popover"
                    aria-label="{{ 'contact.form.propertyType.placeholder' | translate }}"
                    formControlName="propertyType">
          @for (type of formTextContent?.propertyTypeDropdown; track type._id) {
            <ion-select-option
              [lang]="languageService.lang()"
              [dir]="languageService.dir()" [value]="type">{{type}}</ion-select-option>
          }
        </ion-select>

        <ion-label>{{formTextContent?.formLabel.noOfUnits}}</ion-label>
        <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                   fill="outline" mode="md"
                   type="number"
                   placeholder="{{ 'contact.form.noOfUnits.placeholder' | translate }}"
                   formControlName="noOfUnits"></ion-input>

        <ion-label>{{formTextContent?.formLabel.additionalDetails}}</ion-label>
        <ion-textarea
          style="height: 100px"
          [errorText]="formTextContent?.formErrorMessages.mandatory"
          fill="outline"
          mode="md"
          placeholder="{{ 'contact.form.message.placeholder' | translate }}"
          formControlName="message"></ion-textarea>
        <ion-label>Upload Company Profile <span>(optional)</span></ion-label>
        @if (!pdfFile) {
          <div class="upload-wrapper-s">
            <input type="file" (change)="fileSelected($event)">
            <div class="_text"><ion-icon name="cloud-upload-outline"></ion-icon>
              Drag drop PDF file here <span>OR <a>Browse files</a></span></div>
          </div>
        } @else {
          <ion-item lines="none">
            <ion-icon name="document-text-outline" slot="start"></ion-icon>
            <ion-label>{{pdfFile?.name}}</ion-label>
            <ion-icon name="close" (click)="pdfFile = null" slot="end"></ion-icon>
          </ion-item>
        }
        <div class="text-align-right">
          <ion-button shape="round"
                      type="submit">{{formTextContent?.formErrorMessages.button}}</ion-button>
        </div>
      </form>

    }

    @case (formTypes.feedback) {
      <form [formGroup]="feedbackForm" (submit)="sendRequest()" [lang]="languageService.lang()" [dir]="languageService.dir()">
        @if (isSuccess) {
          <div class="success-message ion-text-center ion-padding">
            <ion-img src="assets/success-check.svg" alt="Success check mark"></ion-img>
            <h4>{{ 'contact.form.success.title' | translate }}</h4>
            <p>{{ 'contact.form.success.subtitle' | translate }}</p>
          </div>

        } @else {
          @if (hideFeedbackForm) {
              <div class="feedback">
                @for (x of [1,2,3,4,5]; track x) {
                  <span (click)="feedbackSelected(x)">
                  <ion-img [src]="'assets/feedback/' + x + '.svg'" alt="Feedback rating"></ion-img>
                </span>
                }
              </div>
          } @else {
            <ion-label>{{formTextContent?.formLabel.name}}</ion-label>
            <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                       fill="outline" mode="md"
                       formControlName="name"
                       placeholder="{{ 'contact.form.name.placeholder' | translate }}"
            ></ion-input>

            <ion-label>{{formTextContent?.formLabel.email}}</ion-label>
            <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                       fill="outline" mode="md"
                       placeholder="{{ 'contact.form.email.placeholder' | translate }}"
                       formControlName="email" type="email"></ion-input>

            <app-select-country [userInput]="prefix" (countrySelected)="countrySelected($event)"></app-select-country>
            <ion-label>{{formTextContent?.formLabel.phone}}</ion-label>
            <ion-input [errorText]="formTextContent?.formErrorMessages.mandatory"
                       fill="outline" mode="md"
                       placeholder="{{ 'contact.form.phone.placeholder' | translate }}"
                       (ionInput)="validateNumber($event)"
                       formControlName="contactNumber">
              <span slot="start">{{prefix}}</span>
            </ion-input>

            <ion-label>{{formTextContent?.formLabel.message}}</ion-label>
            <ion-textarea
              style="height: 100px"
              [errorText]="formTextContent?.formErrorMessages.mandatoryError"
              fill="outline"
              mode="md"
              placeholder="{{ 'contact.form.message.placeholder' | translate }}"
              formControlName="message"></ion-textarea>
            <div class="text-align-right">
              <ion-button type="submit">{{ formTextContent?.formErrorMessages.button }}</ion-button>
            </div>
          }
        }
      </form>
    }
  }

</ion-card>
